import graphqlFetch from "@lib/graphql-fetch";
import * as Sentry from "@sentry/node";

const updateCustomerMutation = `
  mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
    customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
      customer {
        phone
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`;

export async function updateShopifyCustomer(customerAccessToken, customer) {
  const data = await graphqlFetch(updateCustomerMutation, {
    variables: {
      customerAccessToken,
      customer,
    },
  });

  return data;
}

export async function updateKlaviyoCustomer(customer) {
  const body = JSON.stringify({
    data: {
      // token: process.env.KLAVIYO_PUBLIC_API_KEY,

      type: "profile",
      token: "LMZu4j",
      attributes: {
        first_name: customer.firstName,
        last_name: customer.lastName,
        email: customer.email,
        phone_number: customer.phone,
      },
    },
  });

  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
      revision: "2023-02-22",
    },
    body: body,
  };

  try {
    const response = await fetch(
      "https://a.klaviyo.com/client/profiles/?company_id=LMZu4j",
      options
    );

    const result = await response.json();

    if (response.ok) {
      return {
        statusCode: 200,
        body: result,
      };
    }

    return {
      statusCode: 422,
      body: result,
    };
  } catch (err) {
    Sentry.captureException(err);
    return {
      statusCode: 500,
      body: String(err),
    };
  }
}
